import React from 'react';
import { VerticalTimeline, VerticalTimelineElement } from 'react-vertical-timeline-component';
import "react-vertical-timeline-component/style.min.css";
import SchoolIcon from '@mui/icons-material/School';
import WorkIcon from "@mui/icons-material/Work"


function Experience(props) {
    return (
        <div className="experience">
        
            
           <VerticalTimeline lineColor="#3e497a">
            <VerticalTimelineElement className='vertical-timeline-element--education' date="2008-2010" iconStyle={{background:"#3e497a", color:"#fff"}} icon={<SchoolIcon/>}><h5 className="vertical-timeline-element-title">Arya Central School, Trivandrum</h5>
            <p>High School Diploma</p></VerticalTimelineElement>
            
            
            <VerticalTimelineElement className='vertical-timeline-element--education' date="2010-2014" iconStyle={{background:"#3e497a", color:"#fff"}} icon={<SchoolIcon/>}><h5 className="vertical-timeline-element-title">Ponjesly College of Engineering, Nagercoil</h5>
            <p>Bachelor of Engineering, Computer Science</p></VerticalTimelineElement>
            
          
            <VerticalTimelineElement className='vertical-timeline-element--education' date="2016-present" iconStyle={{background:"green", color:"#fff"}} icon={<WorkIcon/>}><h5 className="vertical-timeline-element-title">Amazon Development Centre, Hyderabad</h5>
            <p>Risk Analyst</p></VerticalTimelineElement>
            
           
            <VerticalTimelineElement className='vertical-timeline-element--education' date="2020-present" iconStyle={{background:"green", color:"#fff"}} icon={<WorkIcon/>}><h5 className="vertical-timeline-element-title">Freelancing</h5>
            <p>Mern Specialist</p></VerticalTimelineElement>
            
            </VerticalTimeline>
        </div>
    );
}

export default Experience;